import { ForecastAssistantButton } from '@e2m-customer-portal/domains';
import { Device, ForecastSlice, MarketLocation } from '@e2m-customer-portal/hooks';
import { CopyPasteForecastButton, DowntimeButton } from '@e2m-customer-portal/ui';
import { getISOWeek, getYear, Interval } from 'date-fns';
import { ForecastProperty, ForecastTarget } from 'generated/graphql';

interface DeviceTableFunctionsProps {
  marketLocation: MarketLocation;
  device: Device;
  interval: Interval;
  slices: readonly ForecastSlice[];
  disableAssistant?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  currentForecastProperty?: ForecastProperty;
}

export function DeviceTableFunctions({
  marketLocation,
  device,
  interval,
  slices,
  disableAssistant,
  currentForecastProperty,
}: Readonly<DeviceTableFunctionsProps>) {
  const isFutureWeek = (dateToCompare: number | Date): boolean => {
    const now = new Date();
    return getISOWeek(dateToCompare) >= getISOWeek(now) || getYear(dateToCompare) > getYear(now);
  };
  return (
    <div
      className="sm:border-t-divider mt-2 flex w-full items-center justify-end gap-2 border-0 px-4 pt-0 sm:pt-2 xl:my-0 xl:w-auto xl:border-none xl:pt-0 2xl:shrink-0"
      onClick={(event) => event.stopPropagation()}
    >
      {currentForecastProperty?.target === ForecastTarget.ESDB && (
        <ForecastAssistantButton
          marketLocation={marketLocation}
          device={device}
          interval={interval}
          disabled={!marketLocation.permissions.editForecast || disableAssistant}
        />
      )}
      {isFutureWeek(new Date(interval.start)) && currentForecastProperty?.target === ForecastTarget.ESDB && (
        <CopyPasteForecastButton
          interval={interval}
          device={device}
          slices={slices}
          disabled={!marketLocation.permissions.editForecast || disableAssistant}
        />
      )}
      {
        <DowntimeButton
          marketLocation={marketLocation}
          device={device}
          currentForecastProperty={currentForecastProperty}
          disabled={!marketLocation.permissions.editForecast}
        />
      }
    </div>
  );
}
